import React, { useEffect, useContext, useState } from "react";
import AuthWizardProvider from "../../common/wizard/AuthWizardProvider";
import { AuthWizardContext } from "../../../context/Context";
import SaiAuthCardLayout from "./SaiAuthCardLayout";
import bgImage from "../../../assets/img/logos/api-award-2022.jpg";
import DirectPayment from "../payment/DirectPayment";

const AutoAdvanceToPayment = () => {
  const { setStep } = useContext(AuthWizardContext);
  useEffect(() => {
    setStep(2);
  }, [setStep]);
  return null;
};

const SaiRegistrationDownload = () => {
  const [registerFormValues, setRegisterFormValues] = useState({});
  const [paymentFormValues, setPaymentFormValues] = useState({});
  const { step, setStep } = useContext(AuthWizardContext) || {}; // safe access after provider

  return (
    <AuthWizardProvider>
      <AutoAdvanceToPayment />
      <SaiAuthCardLayout bgProps={{ image: bgImage }}>
        <DirectPayment
          registerFormValues={registerFormValues}
          setRegisterFormValues={setRegisterFormValues}
          setStep={setStep}
          step={2} // ensure RegisterPayment receives 2
          setPaymentFormValues={setPaymentFormValues}
          paymentFormValues={paymentFormValues}
        />
      </SaiAuthCardLayout>
    </AuthWizardProvider>
  );
};

export default SaiRegistrationDownload;